export default __webpack_public_path__ + "static/media/no-data.0a9b3dc1.png";